import { createContext, useContext, useState } from 'react';

const ShiftContext = createContext(null);

export function ShiftProvider({ children }) {
  const [activeShift, setActiveShift] = useState(() => {
    return localStorage.getItem('lpo_active_shift') || 'all';
  });

  const setShift = (shift) => {
    setActiveShift(shift);
    localStorage.setItem('lpo_active_shift', shift);
  };

  return (
    <ShiftContext.Provider value={{ activeShift, setShift }}>
      {children}
    </ShiftContext.Provider>
  );
}

export function useShift() {
  return useContext(ShiftContext);
}
